import type { InputHTMLAttributes } from 'react'

import classNames from '../../utils/classNames'

interface CheckboxProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  icon?: 'circle' | 'check'
  iconColor?: string
  className?: string
}

const Checkbox = (props: CheckboxProps) => {
  const {
    className,
    icon = 'circle',
    iconColor = 'text-[#ccc] dark:text-white',
    ...restProps
  } = props
  return (
    <div
      className={classNames(
        'inline-grid place-items-center w-[15px] h-[15px]',
        'ring-2 ring-[#ccc] dark:ring-white rounded-full',
        className,
      )}>
      <input type="checkbox" {...restProps} className="hidden peer" />
      <span
        className={classNames(
          'inline-grid place-items-center w-2/3 h-2/3 aspect-square transition-all duration-200 ease-in-out',
          // Note: I used the props?.checked because the input checkbox doesn't populate the 'checked' attribute
          // I'm not sure why it doesn't populate the 'checked' attribute. please changed this to 'peer'
          restProps?.checked ? 'opacity-1' : 'opacity-0',
          // TODO: Used this if you fixed the 'checked' attribute
          // 'opactiy-0 peer-checked:opacity-1',
          iconColor,
        )}>
        {icon === 'circle' ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 78 78"
            fill="currentColor">
            <circle cx="39.4766" cy="38.7852" r="36" strokeWidth="5" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 40"
            fill="currentColor">
            <path d="M20.0819 25.7125C20.9109 24.8041 21.6834 23.9274 22.4848 23.0823C25.0383 20.3872 27.5974 17.6972 30.1621 15.0122C33.1297 11.8893 36.0953 8.76425 39.0589 5.63712C40.6208 3.98597 42.1899 2.32976 43.7686 0.689974C44.6168 -0.194348 45.8327 -0.242355 46.6869 0.625543C48.1395 2.09983 49.562 3.60823 50.9641 5.13558C51.8051 6.04895 51.828 7.21121 50.9882 8.12206C49.0826 10.1926 47.1315 12.2152 45.1959 14.2542C41.324 18.3322 37.4509 22.4089 33.5766 26.4844C30.1973 30.0385 26.8164 33.5918 23.4339 37.1442C22.8404 37.7683 22.2505 38.3974 21.6546 39.0203C20.5889 40.1358 19.4067 40.1067 18.347 38.9861C14.7258 35.1549 11.099 31.3292 7.46657 27.5089C5.23746 25.1549 3.01236 22.7967 0.791271 20.4343C-0.280429 19.2872 -0.255198 18.0884 0.816502 16.9577C2.10366 15.6017 3.39163 14.2483 4.68039 12.8974C5.73767 11.7933 6.89708 11.7806 7.93754 12.881C11.7742 16.9396 15.6056 21.0024 19.4319 25.0694C19.6013 25.2514 19.7827 25.4169 20.0819 25.7125Z" />
          </svg>
        )}
      </span>
    </div>
  )
}

export default Checkbox
